import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

class CompanySellerConnectionModel extends ShModel {
  @attr('boolean') invited;
  @attr('boolean') inExtendedNetwork;
  @attr('boolean') transacted;
  @attr('boolean') follow;
  @attr('date') lastHired;
  @attr('number') activeProjects;
  @attr('number') completedProjects;
  @attr('number') ytdEarningsInCents;
  @attr('number') lifetimeEarningsInCents;
  @attr('number') rating;
  @attr('number') companyId;
  @attr('number') sellerId;
  @attr('json') fees;

  @belongsTo('user', { async: false }) seller;
  @belongsTo('company', { async: false}) company;

  get selectFee() {
    return this.fees['select_fee'];
  }
}

export default CompanySellerConnectionModel;
